import React from 'react';
import Chart from 'react-apexcharts';

const LineChart = ({ 
  data = [], 
  categories = [], 
  title = "Line Chart",
  height = 350,
  colors = ['#3B82F6'],
  strokeWidth = 2,
  dataLabel = "Data"
}) => {
  const options = {
    chart: {
      type: 'line',
      height: height,
      zoom: {
        enabled: false
      },
      toolbar: {
        show: false
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'smooth',
      width: strokeWidth
    },
    title: {
      text: title,
      align: 'left',
      style: {
        fontSize: '16px',
        fontWeight: 600,
        color: '#374151'
      }
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'],
        opacity: 0.5
      },
    },
    xaxis: {
      categories: categories,
      labels: {
        style: {
          colors: '#6B7280',
          fontSize: '12px'
        }
      }
    },
    yaxis: {
      labels: {
        style: {
          colors: '#6B7280',
          fontSize: '12px'
        }
      }
    },
    colors: colors,
    legend: {
      show: true,
      position: 'top',
      horizontalAlign: 'right'
    },
    tooltip: {
      theme: 'light'
    }
  };

  const series = [{
    name: dataLabel,
    data: data
  }];

  return (
    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm">
      <Chart 
        options={options} 
        series={series} 
        type="line" 
        height={height} 
      />
    </div>
  );
};

export default LineChart;
